import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthInterceptor } from "../interceptors/auth.interceptor";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import {
    DevBackend,
    DevTools,
    FormatSimple, LanguageDetector, LanguageStorage,
    NgxTolgeeModule,
    TOLGEE_INSTANCE,
    Tolgee
} from '@tolgee/ngx';
import { AuthService } from 'src/services/auth.service';
import { environment } from "../environments/environment";
import { SharedModule } from './_shared/shared.module';
import { FormlyModule } from './_shared/formly/form.module';

@NgModule({
    declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        NgxTolgeeModule,
        BrowserAnimationsModule,
        SharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        FormlyModule
    ],
    providers: [
        AuthService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: TOLGEE_INSTANCE,
            useFactory: () => {
                return Tolgee()
                    .use(DevTools())
                    .use(DevBackend())
                    .use(FormatSimple())
                    .use(LanguageDetector())
                    .use(LanguageStorage())
                    .init({
                        defaultLanguage: 'en',
                        availableLanguages: ['en', 'nl', 'es', 'da', 'sv', 'no', 'it', 'fr', 'de'],
                        // for development
                        apiUrl: environment.tolgeeApiUrl,
                        apiKey: environment.tolgeeApiKey,
                    });
            },
        },
        provideHotToastConfig({
            position: 'top-right',
        }),
        provideHttpClient(withInterceptorsFromDi())
    ]
})

export class AppModule { }

